<template>
    <div class="col-12 col-sm-11 col-md-9 col-lg-6">
        <div class="content device-type">
            <LoadingSection v-if="loading" :showMessage="false" />
            <div class="wrapper">
                <GraphPie v-if="!loading" :chartData="pieChartData" :disableTooltip="true" />
                <ul v-if="!loading" class="stats">
                    <li class="stat" v-if="deviceStats.desktop">
                        <div class="name">{{ $t('views.dashboard.sections.analytics_device_type.desktop') }}</div>
                        <div class="value">{{ formatNumber(deviceStats.desktop) }}</div>
                    </li>
                    <li class="stat" v-if="deviceStats.mobile">
                        <div class="name">{{ $t('views.dashboard.sections.analytics_device_type.mobile') }}</div>
                        <div class="value">{{ formatNumber(deviceStats.mobile) }}</div>
                    </li>
                    <li class="stat" v-if="deviceStats.tablet">
                        <div class="name">{{ $t('views.dashboard.sections.analytics_device_type.tablet') }}</div>
                        <div class="value">{{ formatNumber(deviceStats.tablet) }}</div>
                    </li>
                </ul>
            </div>
            <div v-if="!loading" class="p disclaimer">{{ $t('views.dashboard.sections.analytics_traffic.disclaimer') }}</div>
        </div>
    </div>
</template>

<script>
    import GraphPie from '@/components/elements/misc/GraphPie.vue';
    import LoadingSection from '@/components/sections/LoadingSection';
    import { mapState } from 'pinia';
    import { useAccountStore } from '@/stores/account';
    import { formatNumber } from '@/utils/formatting';

    export default {
        name: "DashboardDeviceType",
        components: {
            GraphPie,
            LoadingSection
        },
        props: {
            loading: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState(useAccountStore, ['hasAccountStats', 'accountStats']),
            deviceStats() {
                const deviceType = this.accountStats?.device_type;
                if (!this.hasAccountStats || typeof deviceType !== 'object' || !deviceType) return {};
                
                return {
                    desktop: deviceType.desktop || 0,
                    mobile: deviceType.mobile || 0,
                    tablet: deviceType.tablet || 0
                };
            },
            pieChartData() {
                return {
                    labels: [
                        this.$t('views.dashboard.sections.analytics_device_type.desktop'),
                        this.$t('views.dashboard.sections.analytics_device_type.mobile'),
                        this.$t('views.dashboard.sections.analytics_device_type.tablet')
                    ],
                    datasets: [{
                        data: [
                            this.deviceStats.desktop,
                            this.deviceStats.mobile,
                            this.deviceStats.tablet
                        ],
                        backgroundColor: ['#0075F2', '#4AAD52', '#F7B538']
                    }]
                };
            }
        },
        methods: {
            formatNumber
        }
    }
</script>